import { Component, OnInit } from '@angular/core';
import { AlertController, ToastController,LoadingController,ModalController } from '@ionic/angular';
import {ModalCrearTrabajadorPage} from '../modal-crear-trabajador/modal-crear-trabajador.page'
import {GranServicioDePTWService}from '../gran-servicio-de-ptw.service'
import { ModalBuscarTrabajadorPage } from '../modal-buscar-trabajador/modal-buscar-trabajador.page';
import * as firebase from 'firebase'
import { ModalEditarTrabajadorPage } from '../modal-editar-trabajador/modal-editar-trabajador.page';
import {ModalActividadesTrabajadorPage} from '../modal-actividades-trabajador/modal-actividades-trabajador.page'
import { ServicioLoadersAlertasService } from '../servicio-loaders-alertas.service';
import { ActionSheetController } from '@ionic/angular';
import { Router } from '@angular/router';
import {TimelineComponent} from '../timeline/timeline.component'

@Component({
  selector: 'app-paso3page',
  templateUrl: './paso3page.page.html',
  styleUrls: ['./paso3page.page.scss'],
})
export class Paso3pagePage implements OnInit {

  arrayDeEmpleados=[]
  creandoActividad=false
  actividadSeleccionada=''
  soporteSeleccionado=''
  rolSeleccionado=''
  arrayActividadesPTW=[]


  constructor( public loadingController: LoadingController, public modalController: ModalController, public granServicioDePTWService:GranServicioDePTWService,public alertController: AlertController,public actionSheetController: ActionSheetController, public servicioLoadersAlertasService:ServicioLoadersAlertasService,private router:Router,public timelineComponent:TimelineComponent) { }

  ngOnInit(){}

  ionViewWillEnter(){
    this.timelineComponent.actualizar()
    this.recargaArraydeTrabajadores()
  }

  ionViewWillLeave(){

  }



  async buscarsiexistetrabajador(){
    const modal = await this.modalController.create({
      component: ModalBuscarTrabajadorPage,
      cssClass: 'modalBuscarTrabajador',
      componentProps: {
        'arrayDeEmpleados':this.arrayDeEmpleados,
      },
      backdropDismiss:false
    });

    modal.onDidDismiss().then((data) => {
      if(data.data.trabajadorexiste==true){
        this.recargaArraydeTrabajadores()
      }else
      if(data.data.trabajadorexiste==false){
        this.crearTrabajador(data.data.tipoId, data.data.cedula);
      } 

    })
    return await modal.present();
  }
  


  async crearTrabajador(tipoId,cedula) {
    const modal = await this.modalController.create({
      component: ModalCrearTrabajadorPage,
      cssClass: 'modalCrearTrabajador',
      componentProps: {
        'tipoId': tipoId,
        'cedula':cedula
      },
      backdropDismiss:false
    
    });
    modal.onDidDismiss().then((data)=>{
      this.recargaArraydeTrabajadores()
    })
    return await modal.present();
  }


  recargaArraydeTrabajadores(){
   this.arrayDeEmpleados=[]

   let query = firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud)
   query.get()
   .then((doc)=>{

      this.arrayDeEmpleados = doc.data().arrayDeEmpleados

      //SI EL arrayActividadesPTW NO EXISTE, LO LLENAMOS A PARTIR DE LAS ACTIVIDADES DE LOS TRABAJADORES
      if(doc.data().arrayActividadesPTW != undefined){
        this.arrayActividadesPTW = doc.data().arrayActividadesPTW 
      }else
      if(doc.data().arrayActividadesPTW == undefined){
        doc.data().arrayDeEmpleados.forEach((element,index) => {
          this.desglosaActividadesDeTrabajadores(element.arraydeactividades)
          if(index == doc.data().arrayDeEmpleados.length -1){

            //...Y ACTUALIZAMOS EN FIREBASE
            firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
              arrayActividadesPTW: this.arrayActividadesPTW
            }).then(()=>{
              this.servicioLoadersAlertasService.presentToast("PTW actualizado / PTW updated")
            }).catch((err)=>{
              this.servicioLoadersAlertasService.alerta("Error",err);
            })

          }
        });
      }

   }).then(()=>{
     this.arrayDeEmpleados.forEach((item,index)=>{
       let querydeEmpleado= firebase.firestore().collection("trabajadores").doc(item.id)
       querydeEmpleado.get().then((doc)=>{
         this.arrayDeEmpleados[index].arl = doc.data().arl
         this.arrayDeEmpleados[index].nombre = doc.data().nombre
         this.arrayDeEmpleados[index].telefono = doc.data().telefono
         this.arrayDeEmpleados[index].fechaAfiliacionARL = doc.data().fechaAfiliacionARL
         this.arrayDeEmpleados[index].urlParafiscales = doc.data().urlParafiscales
         this.arrayDeEmpleados[index].urlCertificadoAlturas = doc.data().urlCertificadoAlturas
         this.arrayDeEmpleados[index].urlCertificadoAptitud = doc.data().urlCertificadoAptitud
         this.arrayDeEmpleados[index].urlCertificadoIzaje = doc.data().urlCertificadoIzaje
         this.arrayDeEmpleados[index].urlCertificadoCONTE = doc.data().urlCertificadoCONTE
         this.arrayDeEmpleados[index].urlCertificadoConfinados = doc.data().urlCertificadoConfinados
         this.arrayDeEmpleados[index].urlCertificadoAptitudConfinados = doc.data().urlCertificadoAptitudConfinados
         this.arrayDeEmpleados[index].urlCertificadoEquiposConfinados = doc.data().urlCertificadoEquiposConfinados
      

       }).catch((err)=>{
         console.log(err)
       })
     })
   })
  //  query.onSnapshot((doc)=>{
  //     this.arrayDeEmpleados = doc.data().arrayDeEmpleados
  //  })
  }

  desglosaActividadesDeTrabajadores(arrayActividadesTrabajador){
    arrayActividadesTrabajador.forEach(actividadTrabajador=>{
      //el some arroja true si hay un item en el array con el parámetro actividad igual
      if(this.arrayActividadesPTW.some((item)=>item.actividad == actividadTrabajador.actividad) == false){
         this.arrayActividadesPTW.push({actividad:actividadTrabajador.actividad, herramientasYcontroles:null})        
      }
    })
  }



  async editarTrabajador(itemId){
    const modal = await this.modalController.create({
      component: ModalEditarTrabajadorPage,
      cssClass: 'modalCrearTrabajador',
      backdropDismiss:false,
      componentProps: {
        'trabajadorID':itemId
      }
    });

    modal.onDidDismiss().then((data) => {
      this.recargaArraydeTrabajadores()

      // if(data.data.trabajadorexiste==true){
      //   console.log ("hasta aca llegamos si existe")
      //   this.recargaArraydeTrabajadores()
      // }else
      // if(data.data.trabajadorexiste==false){
      //   console.log ("no existe tipoid "+data.data.tipoId)
      //   this.crearTrabajador(data.data.tipoId, data.data.cedula);
      // } 

    })
    return await modal.present();
  }


  async presentActionSheetTareas(item,i) {
    const actionSheet = await this.actionSheetController.create({
      header: 'Seleccione una tarea',
      // cssClass: 'my-custom-class',
      buttons: [
        {
          text: 'TRABAJO EN ALTURAS / WORK AT HEIGHTS',
          icon: 'arrow-up',
          handler: () => {
           this.agregarActividadTrabajador(item,i, 'TRABAJO EN ALTURAS')
          }
        }, 
        {
          text: 'TRABAJO EN CALIENTE / HOT WORK',
          icon: 'flame',
          handler: () => {
           this.agregarActividadTrabajador(item,i, 'TRABAJO EN CALIENTE')
          }
        }, 
        {
          text: 'LEVANTAMIENTO MECÁNICO / LIFTING',
          icon: 'basket',
          handler: () => {
           this.agregarActividadTrabajador(item,i, 'LEVANTAMIENTO MECÁNICO')
          }
        }, 
        {
          text: 'ENERGÍAS PELIGROSAS / HAZARDOUS ENERGIES',
          icon: 'flash',
          handler: () => {
           this.agregarActividadTrabajador(item,i, 'ENERGÍAS PELIGROSAS')
          }
        }, 
        {
          text: 'ESPACIOS CONFINADOS / CONFINED SPACES',
          icon: 'contract',
          handler: () => {
           this.agregarActividadTrabajador(item,i, 'ESPACIOS CONFINADOS')
          }
        }, 
        {
          text: 'HAZMAT',
          icon: 'beaker',
          handler: () => {
           this.agregarActividadTrabajador(item,i, 'HAZMAT')
          }
        }, 
        {
          text: 'SUPERVISIÓN Y MONITOREO / SUPERVISING AND MONITORING',
          icon: 'search',
          handler: () => {
           this.agregarActividadTrabajador(item,i, 'SUPERVISIÓN Y MONITOREO')
          }
        }, 
        {
          text: 'OTROS / OTHERS',
          icon: 'help-circle',
          handler: () => {
           this.agregarActividadTrabajador(item,i, 'OTROS')
          }
        }, 
    
      ]
    });
    await actionSheet.present();
  }


  agregarActividadTrabajador(trabajador,i,actividad){
    //primero revisamos si esa actividad ya existe en el array de actividades 
    if (trabajador.arraydeactividades.filter(e => e.actividad === actividad).length > 0) {
      /* array contains the element we're looking for */
      this.servicioLoadersAlertasService.alerta("Actividad ya asignada / Task already assigned","Este trabajador ya tiene asignada una actividad de "+actividad+". Seleccione otra opción. / The worker has already assigned this task. Select another option")
    }else{
      this.presentmodalActividades(trabajador,i,actividad,{},'crear')
    }
  }

  editarActividad(actividad,indiceactividad,trabajador,indicetrabajador){
    this.presentmodalActividadesParaEditar(actividad,indiceactividad,trabajador,indicetrabajador,'editar')
  }

  

  async confirmaEliminarActividad(indiceActividad,i,actividad) {
    const alert = await this.alertController.create({
      // cssClass: 'my-custom-class',
      header: '¿Eliminar activdidad? / Delete task?',
      message: '<strong>¿Seguro que quiere eliminar esta tarea?</strong> / <strong>Are you sure you want to delete this task?</strong>',
      buttons: [
        {
          text: 'Cancelar / Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Eliminar / Delete',
          handler: () => {
            this.eliminarActividad(indiceActividad,i,actividad)
          }
        }
      ]
    });
    await alert.present();
  }
  

  eliminarActividad(indiceActividad,i,actividad){

      //PRIMERO ELIMINAMOS EN ACTIVIDADES DEL TRABAJADOR...
      this.arrayDeEmpleados[i].arraydeactividades.splice(indiceActividad,1)

      //LUEGO VERIFICAMOS QUE NINGUN OTRO TRABAJADOR TENGA ESTA ACTIVIDAD PARA BORRARLA DEL ARRAY DE ACTIVIDADES DEL PTW      
        this.buscaActividadAEliminarEnOtrosTrabajadores(actividad)
        .then((respuesta:number)=>{
          //SI LA ACTIVIDAD SI ESTÁ REPETIDA EN OTRO TRABAJADOR NO LA BORRO DEL ARRAY DE ACTIVIDADES DEL PTW
          if(respuesta > 0){

            //...Y ACTUALIZAMOS EN FIREBASE
            firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
              arrayDeEmpleados:this.arrayDeEmpleados,
              arrayActividadesPTW: this.arrayActividadesPTW
            }).then(()=>{
              this.servicioLoadersAlertasService.presentToast("¡Actividad eliminada! / Task deleted!")
            }).catch((err)=>{
              this.servicioLoadersAlertasService.alerta("Error",err);
            })
      
          }else
          //SI LA ACTIVIDAD NO ESTÁ REPETIDA EN OTRO TRABAJADOR LA BORRO DEL ARRAY DE ACTIVIDADES DEL PTW
          if(respuesta == 0){

            //BUSCAMOS EL INDICE DE LA ACTIVIDAD EN EL ARRAY DE ACTIVIDADES DEL PTW
            const index = this.arrayActividadesPTW.findIndex(item => item.actividad == actividad);
            this.arrayActividadesPTW.splice(index,1)

            //...Y ACTUALIZAMOS LOS DOS ARRAYS EN FIREBASE
            firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
              arrayDeEmpleados:this.arrayDeEmpleados,
              arrayActividadesPTW: this.arrayActividadesPTW
            }).then(()=>{
              this.servicioLoadersAlertasService.presentToast("¡Actividad eliminada! / Task deleted!")
            }).catch((err)=>{
              this.servicioLoadersAlertasService.alerta("Error",err);
            })

          }
        })
  }


  buscaActividadAEliminarEnOtrosTrabajadores(actividadABuscar){
    let ocurrenciasDeActividad=0
    return new Promise ((resolve=>{
      this.arrayDeEmpleados.forEach((empleado, index)=>{
        if(empleado.arraydeactividades.some((item)=>item.actividad == actividadABuscar) == true){
          ocurrenciasDeActividad ++
        }
        if(index == this.arrayDeEmpleados.length-1){
          resolve(ocurrenciasDeActividad)
        }
      })
    }))
  }


  async presentmodalActividadesParaEditar(actividad,indiceactividad,trabajador,indicetrabajador,crearOeditar){
    const modal = await this.modalController.create({
      component: ModalActividadesTrabajadorPage,
      cssClass: 'modalActividadesTrabajador',
      backdropDismiss:false,
      componentProps: {
        'actividadParaEditar':actividad,
        'indiceActividadParaEditar':indiceactividad,
        'trabajador':trabajador,
        'indicetrabajador':indicetrabajador,
        'crearOeditar':crearOeditar,
        'arrayDeEmpleados':this.arrayDeEmpleados,
      }
    });
  
    modal.onDidDismiss().then((data) => {
      //   console.log ("tipoID: "+data.data.tipoId)
    })
    return await modal.present();
  }



async presentmodalActividades(trabajador,indice,actividad,dataActividad,crearOeditar){
  const modal = await this.modalController.create({
    component: ModalActividadesTrabajadorPage,
    cssClass: 'modalActividadesTrabajador',
    backdropDismiss:false,
    componentProps: {
      'trabajador': trabajador,
      'actividadSeleccionada':actividad,
      'indicetrabajador':indice,
      'arrayDeEmpleados':this.arrayDeEmpleados,
      'dataActividad':dataActividad,
      'crearOeditar':crearOeditar,
      'arrayActividadesPTW':this.arrayActividadesPTW
    }
  });

  modal.onDidDismiss().then((data) => {
    //   console.log ("tipoID: "+data.data.tipoId)
  })
  return await modal.present();
}


  




  // async eliminarTrabajador(i) {
  //   const alert = await this.alertController.create({
  //     header: "¿Eliminar trabajador?",
  //     message: "¿Está seguro de retirar este trabajador del equipo de trabajo?",
  //     buttons: [
  //       {
  //         text: 'OK',
  //         handler: () => {

  //           this.arrayDeEmpleados.splice(i,1)
  //           firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
  //             arrayDeEmpleados:this.arrayDeEmpleados,
  //             arrayActividadesPTW:this.arrayActividadesPTW
  //           }).then(()=>{
  //             this.servicioLoadersAlertasService.presentToast("Trabajador eliminado de la selección")
  //           }).catch((err)=>{
  //             this.servicioLoadersAlertasService.alerta("Error", err)
  //           })

  //        }
  //       },
  //       {
  //         text: 'Cancelar',
      
  //       }

  //     ]
  //   });
  //   await alert.present();
  // }


  //PARA ELIMINAR UN TRABAJADOR HACEMOS UN RECORRIDO POR TODAS LAS TAREAS DEL TRABAJADOR Y BUSCAMOS SI EXISTEN EN LOS ARRAYS DE LOS OTROS TRABAJADORES
  //SI NO EXISTEN EN LOS ARRAYS DE LOS OTROS TRABAJADORES SI LAS BORRAMOS. SI NO LAS DEJAMOS QUIETAS
   async eliminarTrabajador(i) {
    let arraydeActividadesParaBuscar = []

    const alert = await this.alertController.create({
      header: "¿Eliminar trabajador? / Delete worker?",
      message: "¿Está seguro de retirar este trabajador del equipo de trabajo? / Are you sure you want to remove this worker from the team?",
      buttons: [
        {
          text: 'OK',
          handler: () => {
            //primero metemos las actividades en una variable temporalmente
            arraydeActividadesParaBuscar = this.arrayDeEmpleados[i].arraydeactividades

            //luego eliminamos al trabajador del array de trabajadores para que las actividades del trabajador eliminado no entren en la busqueda. 
            this.arrayDeEmpleados.splice(i,1)

            //ahora si buscamos esas actividades entre los otros trabajadores
            arraydeActividadesParaBuscar.forEach((actividad,indicedearraydeActividadesParaBuscar)=>{

              this.buscaActividadAEliminarEnOtrosTrabajadores(actividad.actividad)
              .then((respuesta:number)=>{
                //SI LA ACTIVIDAD SI ESTÁ REPETIDA EN OTRO TRABAJADOR NO LA BORRO DEL ARRAY DE ACTIVIDADES DEL PTW
                if(respuesta > 0){
                }else
                //SI LA ACTIVIDAD NO ESTÁ REPETIDA EN OTRO TRABAJADOR LA BORRO DEL ARRAY DE ACTIVIDADES DEL PTW
                if(respuesta == 0){
                  //BUSCAMOS EL INDICE DE LA ACTIVIDAD EN EL ARRAY DE ACTIVIDADES DEL PTW
                  let index = this.arrayActividadesPTW.findIndex(item => item.actividad == actividad.actividad);
                  this.arrayActividadesPTW.splice(index,1)
                }
              }).then(()=>{
                if(indicedearraydeActividadesParaBuscar == arraydeActividadesParaBuscar.length -1){
                  //...Y ACTUALIZAMOS LOS DOS ARRAYS EN FIREBASE
                    firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
                      arrayDeEmpleados:this.arrayDeEmpleados,
                      arrayActividadesPTW: this.arrayActividadesPTW
                    }).then(()=>{
                      this.servicioLoadersAlertasService.presentToast("¡Actividad eliminada! / Task deleted!")
                    }).catch((err)=>{
                      this.servicioLoadersAlertasService.alerta("Error",err);
                    })
                }
              })

              
              
            })
              

         }
        },
        {
          text: 'Cancelar',
        }
      ]
    });
    await alert.present();
  }

 









  asignaRol(){
    firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
      arrayDeEmpleados:this.arrayDeEmpleados,
    }).then(()=>{
      this.servicioLoadersAlertasService.presentToast("¡Rol asigando! / Role assigned!")
    }).catch((err)=>{
      this.servicioLoadersAlertasService.alerta("Error", err)
    })
  }


  seleccionaSoporte(){
     window.open(this.soporteSeleccionado)
  }

  // item.arraydeactividades
  // navegar('/paso4page')

  navegar(entrada){
    this.router.navigateByUrl(entrada);
 } 


 continuar(){

  if(this.arrayDeEmpleados.length==0){
    this.servicioLoadersAlertasService.alerta("No hay trabajadores asignados","Agregue al menos un trabajador para continuar" )
  }

  let arraydeempleadossinactividad=[]
  this.arrayDeEmpleados.forEach((item,index)=>{
    if(item.arraydeactividades.length == 0){
      arraydeempleadossinactividad.push(item.nombre)
      if(index == this.arrayDeEmpleados.length-1){
        this.servicioLoadersAlertasService.alerta("Trabajador sin actividad asignada","Los siguientes trabajadores no tienen una actividad asignada: "+arraydeempleadossinactividad.join(", ")+" Agregue al menos una actividad a cada trabajador para continuar.")
      }
    }
    if(index == this.arrayDeEmpleados.length-1 && arraydeempleadossinactividad.length==0){
      firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
        "objetoPasosCompletados.paso3":"ok"
      })
      // this.timelineComponent.avanzar('3')
      this.navegar('/paso3Apage');
    }
  })
 }

 regresar(){
  this.navegar("/paso2page")
 }

 volveramenu(){
  this.navegar("/menu")
 }





}//fin de clase
